import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-hashimoto-diet',
	landing: {
		ids: ['loader-f-hashimoto-diet'],
		route: {
			path: '/hashimoto-diet-f',
			name: 'female-hashimoto-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-hashimoto-diet',
		route: {
			path: '/hashimoto-diet-f/ob/:page(.*)?',
			name: 'female-hashimoto-diet',
		},
		slug: 'female-hashimoto-diet',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ar',
			'ja',
		],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-hashimoto-diet-f',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
}

export default appAreaConfig
